<template>
  <ContainerComponent class="view-container">
    <div class="tile sm-12">
      <i class="icon icon-arrow-left text-xl" @click="$router.back()" />
      <h1>Custom selection of products</h1>
      <div class="row sm-12">
        <div class="col">
          <div class="card">
            <div class="header">
              <div class="left">
                <div class="title">Card title</div>
                <div class="subtitle">Subtitle</div>
              </div>
            </div>
            <div class="content">
              <p>
                Short description on the card content area. Although you can
                have multiple lines of text here. The test should wrap within
                the content section of the card.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>
<script>
import { Card } from '@eds/vanilla';
import { ContainerComponent } from '@/components';
export default {
  components: {
    ContainerComponent
  },
  mounted() {
    const cards = document.querySelectorAll('.card');

    if (cards) {
      Array.from(cards).forEach(cardDOM => {
        const card = new Card(cardDOM);
        card.init();
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
.icon-arrow-left {
  position: absolute;
  bottom: @space-base;
  left: @space-base;
  cursor: pointer;
}
.tile {
  width: 100%;
  height: 100%;
}
</style>
